export const MENU_STEPS = [
  {
    element: '#menuShowlogo',
    popover: {
      title: '全新展示',
      description: '点击logo展开全局菜单栏，移开logo区域快速收起，节省空间',
      popoverClass: 'driverjs-white'
    }
  },
  {
    element: '#menuShow',
    popover: {
      title: '全局列表',
      description: '这里平铺展示所有菜单，可助你快速定位',
      popoverClass: 'driverjs-blue'
    }
  },
  {
    element: '#commonMenu',
    popover: {
      title: '常用菜单',
      description: '这里可以查看常用的菜单，快速找到你经常使用的功能',
      popoverClass: 'driverjs-blue'
    }
  },
  {
    element: '#menuSearch',
    popover: {
      title: '快速搜索',
      description: '输入菜单关键字，快速定位你所需的功能菜单',
      popoverClass: 'driverjs-blue',
      nextBtnText: '我知道了'
    }
  }
]
